// extracted by mini-css-extract-plugin
module.exports = {"page":"dynamo-offer-card_page__krkVe","page__body":"dynamo-offer-card_page__body__iR2kE"};